export default __webpack_public_path__ + "static/media/mockupAndroid.6ad36598.png";